var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [{ name: "title", rawName: "v-title" }],
      staticClass: "flex column",
      attrs: { "data-title": "意见反馈" }
    },
    [
      _c(
        "div",
        { staticStyle: { "padding-top": "20px" } },
        _vm._l(_vm.list, function(item, index) {
          return _c("div", { key: index }, [
            _c(
              "div",
              {
                staticClass: "flex column",
                staticStyle: { "margin-left": "28px" }
              },
              [
                _c("div", { staticClass: "flex" }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "15px",
                        color: "#030303FF",
                        "font-weight": "bolder"
                      }
                    },
                    [_vm._v(_vm._s(index + 1) + ". ")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex column" }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "font-size": "15px",
                          color: "#030303FF",
                          "font-weight": "bold"
                        }
                      },
                      [_vm._v(_vm._s(item.title))]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: { "font-size": "14px", color: "#878787FF" }
                      },
                      [_vm._v("联系：" + _vm._s(item.name))]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: { "font-size": "14px", color: "#878787FF" }
                      },
                      [_vm._v("微信：" + _vm._s(item.wx))]
                    )
                  ])
                ])
              ]
            )
          ])
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e1a7d96", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e1a7d96","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Feedback.vue
// module id = null
// module chunks = 